import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxCaptchaModule } from 'ngx-captcha';

import { AuthUserDetailsComponent } from './auth-user-details/auth-user-details.component';
import { FormsModule } from '@angular/forms'
import { HarelCommonModule } from '../harel-common/harel-common.module';
import { ModalModule, ButtonModule, FieldModule, SpinnerModule } from 'hsg';
import { AuthUserOtpComponent } from './auth-user-otp/auth-user-otp.component';
import { AuthValidateDetailsComponent } from './auth-validate-details/auth-validate-details.component';
import { AuthIssueDateComponent } from './auth-issue-date/auth-issue-date.component';
import { AuthAuthenticateMethodComponent } from './auth-authenticate-method/auth-authenticate-method.component';
import { AuthChangePasswordComponent } from './auth-change-password/auth-change-password.component';

import { AuthUserActivationComponent } from './auth-user-activation/auth-user-activation.component';
import { AuthEndProcessComponent } from './auth-end-process/auth-end-process.component';
import { AuthCreditCardComponent } from './auth-credit-card/auth-credit-card.component';
import { AuthPermanentPasswordComponent } from './auth-permanent-password/auth-permanent-password.component';
import { AuthCustomerServiceComponent } from './auth-customer-service/auth-customer-service.component';
import { AuthOpenCallsComponent } from './auth-open-calls/auth-open-calls.component';
import { AuthBaseComponent } from './auth-base/auth-base.component';
import { AuthSuccessRegistrationComponent } from './auth-success-registration/auth-success-registration.component';
import { AuthLoaderComponent } from './auth-loader/auth-loader.component';
import { AuthStrictIdChoiceComponent } from './auth-strict-id-choice/auth-strict-id-choice.component';
// import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
// import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxCaptchaModule.forRoot({
      reCaptcha2SiteKey: '6LeASWQUAAAAAPhmSKSEbzxwNXWIK4_Xz3VRAfqg', // optional, can be overridden with 'siteKey' component property
      invisibleCaptchaSiteKey: '6LdIj2kUAAAAAKlAR2c5m8YfB0xxz7gjalaCG_6a' // optional, can be overridden with 'siteKey' component property
    }),
    HarelCommonModule,
    ModalModule,
    ButtonModule,
    FieldModule,
    SpinnerModule
  ],
  declarations: [
    AuthUserDetailsComponent, 
    AuthUserOtpComponent,
    AuthValidateDetailsComponent,
    AuthIssueDateComponent,
    AuthAuthenticateMethodComponent,
    AuthChangePasswordComponent,
    AuthUserActivationComponent,
    AuthEndProcessComponent,
    AuthCreditCardComponent,
    AuthPermanentPasswordComponent,
    AuthCustomerServiceComponent,
    AuthOpenCallsComponent,
    AuthBaseComponent,
    AuthSuccessRegistrationComponent,
    AuthLoaderComponent,
    AuthStrictIdChoiceComponent
  ],
  exports: [AuthUserDetailsComponent]
})
export class AuthenticationModule { }
